import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory'
import { createStore, combineReducers, applyMiddleware } from 'redux'
import { routerReducer, routerMiddleware } from 'react-router-redux'

export const history = createHistory()
const middleware = routerMiddleware(history)

import authReducer from './reducers/auth'
import apiReducer from './reducers/api'
import stateReducer from './reducers/state'

export const store = createStore(
  combineReducers({
    session: authReducer,
    api: apiReducer,
    state: stateReducer,
    router: routerReducer
  }),
  applyMiddleware(thunk),
  applyMiddleware(middleware)  
)